import script from "./workbench-today.vue?vue&type=script&setup=true&lang=js"
export * from "./workbench-today.vue?vue&type=script&setup=true&lang=js"

import "./workbench-today.vue?vue&type=style&index=0&id=45703bb2&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45703bb2"]])

export default __exports__